import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import styled from 'styled-components';

import '../../scss/SimpleDocumentList.scss';

const StyledTag = styled(M.Tag)`
  background-color: transparent;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
`;

const StyledIcon = styled(M.Icon)`
  fill: #1a2026a6;
  margin: 2px;
`;

type SimpleDocumentListProps = {
  documents: Array<any>;
  onRemove?: (index: number) => void;
  onRemoveByUploadId?: (uploadId: string, exceptionId: string) => void;
  useTagStyle?: boolean;
};

const SimpleDocumentList: React.FC<SimpleDocumentListProps> = ({
  documents,
  onRemove = () => {},
  onRemoveByUploadId = () => {},
  useTagStyle = false,
}) => (
  <div>
    {documents.map((doc, i) => (
      <div key={`document-${doc.handle}`} className='d-flex align-items-center'>
        {useTagStyle ? (
          <StyledTag
            data-testid='default-worksite'
            filter='true'
            onClose={() => onRemoveByUploadId(doc.uploadId, doc.exceptionId)}
            className='tag-file'
          >
            <StyledIcon
              icon={
                doc.mimetype === 'application/pdf' ? 'DocumentPdf' : 'Document'
              }
              className='icon-file'
            />
            {doc.filename}
          </StyledTag>
        ) : (
          <>
            <div data-testid='success-icon' className='success-icon'>
              <M.Icon icon='CheckmarkFilled' />
            </div>
            <p className='no-link-file-name'>{doc.filename}</p>
            <div
              className='remove-doc'
              onClick={() => onRemove(i)}
              role='button'
              tabIndex={0}
            >
              <M.Icon icon='TrashCan' className='remove-icon' />
            </div>
          </>
        )}
      </div>
    ))}
  </div>
);

export default SimpleDocumentList;
